<template>
  <div class="uploader">
    <el-upload
      v-model:file-list="fileList"
      ref="uploadRef"
      action="#"
      accept="image/*"
      list-type="picture-card"
      :limit="1"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :on-exceed="handleExceed"
      :http-request="httpRequest"
    >
      <div class="upload-box" v-show="!base64File" ref="uploadBoxEl">
        <el-icon size="20" color="#dfdfdf"><Plus /></el-icon>
      </div>
    </el-upload>
    <Dialog v-model="dialogImgVisible" title="图片预览" top="5vh">
      <img :src="dialogImageUrl" alt="Preview Image" style="width: 100%" />
    </Dialog>
  </div>
</template>

<script setup>
import { nextTick, ref, watch } from "vue";
import Dialog from "@/components/Common/Dialog.vue";
import fileToBase64 from "@/utils/fileToBase64.js";
import compressFile from "@/utils/compressFile.js";
import { genFileId } from "element-plus";
import base64ToFile from "@/utils/base64ToFile.js";

const fileList = ref([]);
const dialogImgVisible = ref(false); //预览图片dialog
const dialogImageUrl = ref(""); //预览图片地址
const uploadRef = ref(null);
const base64File = defineModel({ default: "", type: String });
const uploadBoxEl = ref(null);

watch(
  base64File,
  (value) => {
    if (value) {
      let file = base64ToFile(value);
      const fileInfo = {
        name: file.name,
        raw: file,
        url: URL.createObjectURL(file),
      };
      fileList.value = [fileInfo];
    }
    nextTick(() => {
      uploadBoxEl.value.parentNode.style.display = !!value ? "none" : ""
    });
  },
  { immediate: true },
);

// 点击文件的钩子 (图片预览)
const handlePictureCardPreview = (uploadFile) => {
  dialogImageUrl.value = uploadFile.url;
  dialogImgVisible.value = true;
};
// 文件删除钩子
const handleRemove = () => {
  base64File.value = "";
  fileList.value = [];
};
// 文件数量超出限制处理
const handleExceed = (files) => {
  uploadRef.value.clearFiles();
  const file = files[0];
  file.uid = genFileId();
  uploadRef.value.handleStart(file);
  httpRequest({ file });
};
// 文件上传的钩子
const httpRequest = async (fileInfo) => {
  const { file } = fileInfo;
  const compressed = await compressFile(file);
  // 将文件转成base64格式存储
  base64File.value = await fileToBase64(compressed);
};

defineExpose({
  base64File,
});
</script>

<style scoped lang="scss">
.uploader{
  display: flex;
  >div{
    display: inline-flex;
  }
}
.upload-box {
  // width: 100px;
  // height: 100px;
  // border: 1px solid #dfdfdf;
  // border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
:deep() {
  .el-upload-list {
    margin: 0;
  }
  .el-upload-list__item {
    margin: 0;
    padding: 0;
    width: 100px;
    height: 100px;
  }
  .el-upload--picture-card{
    width: 100px;
    height: 100px;
    border: 1px solid #dfdfdf;
    background-color: #fff;
  }
}
</style>
